import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import { useStore } from "vuex";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateFolderModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    estateId: {
      type: String,
      required: true,
    },
    folderPath: {
      type: String,
      required: true,
    },
  },
  emits: ["update", "close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;
  const props = __props;
  const form = reactive({
    foldername: "",
  });
  const rules = {
    foldername: { required },
  };
  const v$ = useVuelidate(rules, form);

  function close() {
    emits("close");
    clear();
  }

  const disabled = ref(false);
  const create = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    disabled.value = true;
    store
      .dispatch("estate/createEstateFolder", {
        estateId: props.estateId,
        foldername: props.folderPath + form.foldername + "/",
      })
      .then((res) => {
        clear();
        emits("update", res.data);
        emits("close");
      })
      .finally(() => {
        disabled.value = false;
      });
  };

  function clear() {
    form.foldername = "";
    resetVuelidateErrors(v$);
  }

const __returned__ = { store, emits, props, form, rules, v$, close, disabled, create, clear, reactive, ref, Modal, get useVuelidate() { return useVuelidate }, get required() { return required }, get useStore() { return useStore }, get resetVuelidateErrors() { return resetVuelidateErrors } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})